import { laravelAxios } from "@/utils/axios";

// 获取订单列表
export const getOrderList = (params: any) =>
  laravelAxios.get(`/api/order/get_order_list_v2`, { params });

// 获取产品列表
export const getProductList = (params: any) =>
  laravelAxios.get(`/api/product_v2/get_product_list`, { params });

// 保存产品
export const saveProduct = (data: any) =>
  laravelAxios.post(`/api/product_v2/save_spu_product`, data, { successMsg: "操作成功" });

// 删除产品
export const deleteProduct = (params: any) =>
  laravelAxios.delete(`/api/product_v2/delete_spu_product`, { data: params, successMsg: "删除成功" });

// 获取预购列表
export const getBookPreConsumeList = (params: any) =>
  laravelAxios.get(`/api/book_pre_consume/get_book_pre_consume_list`, { params });

// 保存预购
export const saveBookPreConsume = (data: any) =>
  laravelAxios.post(`/api/book_pre_consume/save_book_pre_consume`, data, { successMsg: "操作成功" });

// 删除预购
export const deleteBookPreConsume = (params: any) =>
  laravelAxios.delete(`/api/book_pre_consume/delete_book_pre_consume`, { data: params, successMsg: "删除成功" });

// 获取SKU列表
export const getSkuList = (params: any) =>
  laravelAxios.get(`/api/product_v2/get_sku_list`, { params });

// 保存SKU
export const saveSku = (data: any) =>
  laravelAxios.post(`/api/product_v2/save_sku_product`, data, { successMsg: "操作成功" });

// 删除SKU
export const deleteSku = (params: any) =>
  laravelAxios.delete(`/api/product_v2/delete_sku_product`, { data: params, successMsg: "删除成功" });

// 获取权益列表
export const getRightsList = (params: any) =>
  laravelAxios.get(`/api/product_v2/get_product_rights_list`, { params });

// 保存权益
export const saveRights = (data: any) =>
  laravelAxios.post(`/api/product_v2/save_product_rights`, data, { successMsg: "操作成功" });

// 删除权益
export const deleteRights = (params: any) =>
  laravelAxios.delete(`/api/product_v2/delete_product_rights`, { data: params, successMsg: "删除成功" });

// 新版预购列表
export const getPreLockList = (params: any) =>
  laravelAxios.get(`/api/pre_lock/get_pre_lock_list`, { params });

// 新版创建预购
export const createPreLock = (data: any) =>
  laravelAxios.post(`/api/pre_lock/create_pre_lock`, data, { successMsg: "操作成功" });

// 新版删除预购
export const deletePreLock = (params: any) =>
  laravelAxios.delete(`/api/pre_lock/delete_pre_lock`, { data: params, successMsg: "删除成功" });

// 下载管理列表
export const getDownloadList = (params: any) =>
  laravelAxios.get(`/api/order/get_order_list`, { params });

// 获取兑换码列表
export const getRedeemCodeList = (params: any) =>
  laravelAxios.get(`/api/redeem_code/get_redeem_codes`, { params });

// 获取兑换码批次列表
export const getRedeemCodeBatchList = (params: any) =>
  laravelAxios.get(`/api/redeem_code/get_redeem_code_batch_list`, { params });

// 生成兑换码
export const genRedeemCode = (data: any) =>
  laravelAxios.post(`/api/redeem_code/gen_redeem_codes`, data, { successMsg: "操作成功" });

// 删除兑换码批次
export const deleteRedeemCodeBatch = (params: any) =>
  laravelAxios.delete(`/api/redeem_code/delete_redeem_code_batch`, { params, successMsg: "删除成功" });

// 打印管理列表
export const getPrintBookRecordList = (params: any) =>
  laravelAxios.get(`/api/print_book_record/get_print_book_record_list`, { params });